export const axiTokens = {
  "primary": "#3867e8",
  "primaryHover": "#2f58d4",
  "success": "#16a34a",
  "warning": "#d97706",
  "danger": "#dc2626",
  "dark": {
    "page": "#1d1d1d",
    "surface": "#141414",
    "elevated": "#262727",
    "border": "#2b2b2c",
    "text": "#e5eaf3",
    "muted": "#8b909c"
  },
  "light": {
    "page": "#eef3f8",
    "surface": "#ffffff",
    "elevated": "#f6f8fc",
    "border": "#d9e4ef",
    "text": "#16213a",
    "muted": "#667085"
  },
  "sidebarWidth": "230px",
  "sidebarCollapsedWidth": "60px",
  "barHeight": "40px",
  "iconSize": "16px",
  "iconButtonSize": "26px",
  "inlinePadding": "10px",
  "contentPadding": "10px",
  "controlRadius": "6px",
  "panelRadius": "8px",
  "cssVariables": {
    "root": {
      "color-scheme": "dark",
      "--axi-primary": "#3867e8",
      "--axi-primary-hover": "#2f58d4",
      "--axi-success": "#16a34a",
      "--axi-warning": "#d97706",
      "--axi-danger": "#dc2626",
      "--axi-sidebar-width": "230px",
      "--axi-sidebar-collapsed-width": "60px",
      "--axi-bar-height": "40px",
      "--axi-control-radius": "6px",
      "--axi-panel-radius": "8px",
      "--axi-breakpoint-sm": "480px",
      "--axi-breakpoint-md": "768px",
      "--axi-breakpoint-lg": "1024px",
      "--axi-breakpoint-xl": "1280px",
      "--axi-bg-page": "#1d1d1d",
      "--axi-bg-surface": "#141414",
      "--axi-bg-elevated": "#262727",
      "--axi-border": "#2b2b2c",
      "--axi-text": "#e5eaf3",
      "--axi-muted": "#8b909c",
      "--sidebar-width": "230px",
      "--sidebar-collapsed-width": "60px",
      "--app-radius": "0.75rem",
      "--app-bar-height": "40px",
      "--app-icon-size": "16px",
      "--app-icon-button-size": "26px",
      "--app-control-radius": "6px",
      "--app-topbar-inline-padding": "10px",
      "--topbar-height": "var(--app-bar-height)",
      "--toolbar-height": "var(--app-bar-height)",
      "--breadcrumb-height": "var(--app-bar-height)",
      "--axi-layout-sidebar-width": "var(--axi-sidebar-width)",
      "--axi-layout-sidebar-collapsed-width": "var(--axi-sidebar-collapsed-width)",
      "--axi-layout-topbar-height": "var(--app-bar-height)",
      "--axi-layout-toolbar-height": "var(--app-bar-height)",
      "--axi-layout-tabbar-height": "var(--app-bar-height)",
      "--axi-layout-breadcrumb-height": "var(--app-bar-height)",
      "--axi-layout-inline-padding": "var(--app-topbar-inline-padding)",
      "--axi-layout-content-padding": "10px",
      "--axi-layout-icon-size": "var(--app-icon-size)",
      "--axi-layout-icon-button-size": "var(--app-icon-button-size)",
      "--axi-layout-control-radius": "var(--app-control-radius)",
      "--axi-layout-panel-radius": "var(--app-radius)",
      "--axi-layout-sidebar-bg": "var(--axi-bg-surface)",
      "--axi-layout-sidebar-text": "var(--axi-text)",
      "--axi-layout-chrome-bg": "var(--axi-bg-page)",
      "--axi-layout-surface": "var(--axi-bg-surface)",
      "--axi-layout-surface-strong": "var(--axi-bg-elevated)",
      "--axi-layout-border": "var(--axi-border)",
      "--axi-layout-control-border": "var(--control-border)",
      "--axi-layout-hover": "var(--surface-hover)",
      "--primary": "#3867e8",
      "--primary-hover": "#2f58d4",
      "--primary-active": "#294cbd",
      "--primary-border": "#5f86f0",
      "--primary-soft": "rgba(56, 103, 232, 0.2)",
      "--primary-softer": "rgba(56, 103, 232, 0.1)",
      "--slider-bg": "#141414",
      "--slider-text": "#e5eaf3",
      "--chrome-bg": "#1d1d1d",
      "--bg": "#1d1d1d",
      "--panel": "#141414",
      "--panel-strong": "#262727",
      "--panel-border": "#2b2b2c",
      "--metric-panel": "#141414",
      "--metric-panel-border": "#2b2b2c",
      "--metric-icon-bg": "#262727",
      "--line": "#2b2b2c",
      "--divider": "#2b2b2c",
      "--surface-hover": "#1d1d1d",
      "--control-border": "#39393a",
      "--floating-bg": "#1b1b1f",
      "--floating-border": "#3a3a3f",
      "--floating-shadow": "0 18px 44px rgba(0, 0, 0, 0.4)",
      "--popover-arrow-border": "var(--floating-border)",
      "--menu-floating-bg": "#151518",
      "--menu-floating-border": "#303038",
      "--divider-strong": "#3a3a45",
      "--scrollbar-thumb": "rgba(144, 147, 153, 0.32)",
      "--scrollbar-thumb-hover": "rgba(144, 147, 153, 0.55)",
      "--avatar-bg": "#8b8d93",
      "--modal-backdrop": "rgba(15, 23, 42, 0.42)",
      "--code-bg": "#101010",
      "--code-text": "#e5edf8",
      "--warning-text": "#7c4a03",
      "--text-inverse": "#ffffff",
      "--login-panel-bg": "rgba(255, 255, 255, 0.96)",
      "--login-text": "#172033",
      "--login-muted": "#64748b",
      "--login-label": "#475569",
      "--login-field-bg": "#ffffff",
      "--login-field-border": "#cbd5e1",
      "--login-error-border": "#f3c1aa",
      "--text": "#e5eaf3",
      "--muted": "#8b909c",
      "--table-header-text": "color-mix(in srgb, var(--text) 76%, var(--muted) 24%)",
      "--table-grid-line": "var(--line)",
      "--green": "#16a34a",
      "--green-bg": "rgba(22, 163, 74, 0.14)",
      "--amber": "#d97706",
      "--amber-bg": "rgba(217, 119, 6, 0.14)",
      "--red": "#dc2626",
      "--red-bg": "rgba(220, 38, 38, 0.14)",
      "--blue": "var(--primary)",
      "--blue-bg": "var(--primary-soft)",
      "--color-primary-main": "var(--primary)",
      "--color-primary-hover": "var(--primary-hover)",
      "--color-primary-active": "var(--primary-active)",
      "--color-primary-focus": "var(--primary-border)",
      "--color-success-main": "var(--green)",
      "--color-warning-main": "var(--amber)",
      "--color-danger-main": "var(--red)",
      "--color-info-main": "var(--blue)",
      "--color-blue-main": "#409eff",
      "--color-cyan-main": "#14b8a6",
      "--color-geekblue-main": "#6366f1",
      "--color-purple-main": "#8b5cf6",
      "--color-magenta-main": "#d946ef",
      "--color-red-main": "var(--red)",
      "--color-volcano-main": "#f97316",
      "--color-orange-main": "#f59e0b",
      "--color-gold-main": "#d97706",
      "--color-lime-main": "#65a30d",
      "--color-green-main": "var(--green)",
      "--color-gray-main": "var(--muted)",
      "--theme-name": "\"dark\"",
      "--theme-color-scheme": "dark",
      "--theme-bg-page": "var(--bg)",
      "--theme-bg-surface": "var(--panel)",
      "--theme-bg-elevated": "var(--panel-strong)",
      "--theme-bg-overlay": "var(--modal-backdrop)",
      "--theme-bg-hover": "var(--surface-hover)",
      "--theme-bg-active": "var(--panel-strong)",
      "--theme-bg-disabled": "var(--panel-strong)",
      "--theme-text-primary": "var(--text)",
      "--theme-text-secondary": "var(--muted)",
      "--theme-text-tertiary": "var(--muted)",
      "--theme-table-header-text": "var(--table-header-text)",
      "--theme-text-disabled": "color-mix(in srgb, var(--muted), transparent 38%)",
      "--theme-text-inverse": "var(--text-inverse)",
      "--theme-border-light": "var(--line)",
      "--theme-border-main": "var(--panel-border)",
      "--theme-border-dark": "var(--control-border)",
      "--theme-border-focus": "var(--primary)",
      "--theme-card-bg": "var(--panel)",
      "--theme-card-border": "var(--panel-border)",
      "--theme-glass-bg": "var(--floating-bg)",
      "--theme-glass-border": "var(--floating-border)",
      "--theme-shadow-md": "var(--floating-shadow)",
      "--theme-button-primary-bg": "var(--primary)",
      "--theme-button-primary-text": "var(--text-inverse)",
      "--theme-button-hover-bg": "var(--primary-hover)",
      "--theme-button-active-bg": "var(--primary-active)",
      "--theme-link-color": "var(--primary)",
      "--theme-link-hover-color": "var(--primary-hover)",
      "--bg-color-base": "var(--theme-bg-page)",
      "--bg-color-surface": "var(--theme-bg-surface)",
      "--bg-color-elevated": "var(--theme-bg-elevated)",
      "--text-color-primary": "var(--theme-text-primary)",
      "--text-color-secondary": "var(--theme-text-secondary)",
      "--text-color-tertiary": "var(--theme-text-tertiary)",
      "--border-color": "var(--theme-border-main)",
      "--border-color-light": "var(--theme-border-light)",
      "--breadcrumb-action-bg": "var(--panel)",
      "--breadcrumb-action-muted": "color-mix(in srgb, var(--text) 48%, var(--muted) 52%)",
      "--breadcrumb-action-text": "var(--text)",
      "--chart-color": "var(--primary)",
      "--axi-icon-button-control-size": "26px",
      "--axi-icon-button-glyph-size": "16px",
      "--axi-tag-color": "var(--primary)",
      "--axi-tag-text": "var(--axi-tag-color)",
      "--axi-tag-bg": "color-mix(in srgb, var(--axi-tag-color), transparent 86%)",
      "--axi-tag-border": "color-mix(in srgb, var(--axi-tag-color), transparent 55%)",
      "--axi-svg-animation-delay": "0s",
      "--axi-svg-animation-duration": "0.3s",
      "font-family": "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"PingFang SC\", \"Segoe UI\", sans-serif"
    },
    "light": {
      "color-scheme": "light",
      "--axi-bg-page": "#eef3f8",
      "--axi-bg-surface": "#ffffff",
      "--axi-bg-elevated": "#f6f8fc",
      "--axi-border": "#d9e4ef",
      "--axi-text": "#16213a",
      "--axi-muted": "#667085",
      "--theme-name": "\"light\"",
      "--theme-color-scheme": "light",
      "--slider-bg": "#121212",
      "--slider-text": "#dfe3ee",
      "--chrome-bg": "#eef3f8",
      "--bg": "#eef3f8",
      "--panel": "#ffffff",
      "--panel-strong": "#f6f8fc",
      "--panel-border": "#d9e4ef",
      "--metric-panel": "#ffffff",
      "--metric-panel-border": "#d9e4ef",
      "--metric-icon-bg": "#121416",
      "--line": "#e4ebf3",
      "--divider": "#e4ebf3",
      "--surface-hover": "#eef4fb",
      "--control-border": "#d5dfeb",
      "--floating-bg": "#ffffff",
      "--floating-border": "#d5dfeb",
      "--floating-shadow": "0 18px 44px rgba(31, 42, 68, 0.14)",
      "--popover-arrow-border": "var(--menu-floating-border)",
      "--menu-floating-bg": "#ffffff",
      "--menu-floating-border": "#dfe7f1",
      "--divider-strong": "#dfe7f1",
      "--scrollbar-thumb": "rgba(144, 147, 153, 0.32)",
      "--scrollbar-thumb-hover": "rgba(144, 147, 153, 0.55)",
      "--modal-backdrop": "rgba(15, 23, 42, 0.28)",
      "--code-bg": "#101010",
      "--code-text": "#e5edf8",
      "--text": "#16213a",
      "--muted": "#667085",
      "--table-header-text": "color-mix(in srgb, var(--text) 78%, var(--muted) 22%)",
      "--green-bg": "rgba(22, 163, 74, 0.14)",
      "--amber-bg": "rgba(217, 119, 6, 0.14)",
      "--red-bg": "rgba(220, 38, 38, 0.14)",
      "--axi-layout-sidebar-bg": "#fbfcff",
      "--axi-layout-sidebar-text": "#243044",
      "--axi-layout-chrome-bg": "#eef3f8",
      "--axi-layout-surface": "#ffffff",
      "--axi-layout-surface-strong": "#f6f8fc",
      "--axi-layout-border": "#d9e4ef",
      "--axi-layout-control-border": "#d5dfeb",
      "--axi-layout-hover": "#eef4fb"
    }
  },
  "themePresets": [
    {
      "label": "默认蓝",
      "name": "default",
      "color": "#5D87FF"
    },
    {
      "label": "浅紫",
      "name": "purple",
      "color": "#B48DF3"
    },
    {
      "label": "天空蓝",
      "name": "sky",
      "color": "#1D84FF"
    },
    {
      "label": "绿色",
      "name": "green",
      "color": "#60C041"
    },
    {
      "label": "青色",
      "name": "cyan",
      "color": "#38C0FC"
    },
    {
      "label": "橙色",
      "name": "orange",
      "color": "#F9901F"
    },
    {
      "label": "粉色",
      "name": "pink",
      "color": "#FF80C8"
    }
  ],
  "primaryShadeMixTarget": "#131313",
  "antdModeTokens": {
    "dark": {
      "colorBgBase": "#121212",
      "colorBgContainer": "#171717",
      "colorBgElevated": "#202020",
      "colorBorder": "#2b2b2b",
      "colorSplit": "#242424",
      "colorText": "#dfe3ee",
      "colorTextSecondary": "#9aa0ad",
      "colorTextTertiary": "#727782"
    },
    "light": {
      "colorBgBase": "#f3f6f8",
      "colorBgContainer": "#ffffff",
      "colorBgElevated": "#ffffff",
      "colorBorder": "#d8e0e8",
      "colorSplit": "#e7edf3",
      "colorText": "#172033",
      "colorTextSecondary": "#667085",
      "colorTextTertiary": "#98a2b3"
    }
  },
  "appIconSystem": {
    "name": "Axi Instrument Glass",
    "owner": "@axi/tokens",
    "primaryHex": "#3867E8",
    "backgroundHex": "#101216",
    "masterSize": 1024,
    "exportSizes": [
      512,
      256,
      128,
      64,
      32,
      16
    ],
    "platformMasks": [
      "macos-dock",
      "tauri-window",
      "android-adaptive"
    ],
    "futureProjectCategories": [
      "workbench",
      "agent",
      "ops",
      "docs",
      "notify",
      "mobile",
      "security/account",
      "gateway",
      "tooling"
    ],
    "basePrompt": "Design a premium square app icon for the Axi application suite. Style: mature enterprise developer tool, dark graphite rounded-square base, subtle glass depth, precise beveled edges, crisp central abstract glyph, Axi trident / axial spine motif integrated into the symbol, high legibility at 16px, no text, no letters, no mascot, no busy background, no generic AI purple gradient. Use Axi primary blue #3867E8 plus one restrained accent color. Centered composition, vector-like clean geometry, polished macOS and Android launcher icon quality, 1024x1024.",
    "negativePrompt": "text, letters, wordmark, realistic photo, cute mascot, cartoon, noisy details, excessive glow, purple-blue blob gradient, flat generic SaaS logo, cluttered dashboard screenshot, thin unreadable lines, low contrast, random symbols, app UI mockup inside icon"
  },
  "appIconSpecs": [
    {
      "id": "axi-workstation",
      "name": "Axi Workstation",
      "category": "workbench",
      "status": "p0",
      "surface": "control plane, resources, audit, orchestration",
      "glyph": "hub",
      "accent": {
        "name": "electric cyan",
        "hex": "#22D3EE"
      },
      "prompt": "Central glyph: command hub made from three converging axial rails around a small core, suggesting control plane, resources, audit, and orchestration. Accent color: electric cyan. Keep the Axi trident spine visible as the structural center."
    },
    {
      "id": "axi-coder",
      "name": "Axi Coder",
      "category": "workbench",
      "status": "p0",
      "surface": "development workbench, terminal, task execution",
      "glyph": "coder",
      "accent": {
        "name": "emerald green",
        "hex": "#10B981"
      },
      "prompt": "Central glyph: angular code bracket fused with a terminal cursor and axial trident spine, like a precision development cockpit. Accent color: emerald green. Avoid literal code text."
    },
    {
      "id": "axi-agent",
      "name": "Axi Agent",
      "category": "agent",
      "status": "p0",
      "surface": "agent runtime, task orchestration, quality gates",
      "glyph": "agent",
      "accent": {
        "name": "violet blue",
        "hex": "#6366F1"
      },
      "prompt": "Central glyph: autonomous node cluster orbiting a vertical Axi spine, three connected decision points forming a disciplined agent workflow. Accent color: violet-blue, restrained and not gradient-dominant."
    },
    {
      "id": "axi-devsvc-dashboard",
      "name": "Axi DevSvc Dashboard",
      "aliases": [
        "axi-ops-console"
      ],
      "category": "ops",
      "status": "p0",
      "surface": "local services, PM2, workspace status",
      "glyph": "services",
      "accent": {
        "name": "signal green",
        "hex": "#22C55E"
      },
      "prompt": "Central glyph: stacked service layers with a pulse line crossing the Axi trident axis, indicating live local services and health monitoring. Accent color: signal green."
    },
    {
      "id": "axi-fleet-console",
      "name": "Axi Fleet Console",
      "category": "ops",
      "status": "p0",
      "surface": "server fleet registry, inventory, ops executor",
      "glyph": "fleet",
      "accent": {
        "name": "amber",
        "hex": "#F59E0B"
      },
      "prompt": "Central glyph: three server towers connected by an axial command path, compact fleet topology, precise operations console feel. Accent color: amber."
    },
    {
      "id": "axi-notify",
      "name": "Axi Notify",
      "category": "notify",
      "status": "p0",
      "surface": "notification relay, workflow events, inbox",
      "glyph": "notify",
      "accent": {
        "name": "coral red",
        "hex": "#F43F5E"
      },
      "prompt": "Central glyph: notification signal wave contained inside the Axi trident frame, with one clean badge dot, no phone UI screenshot. Accent color: coral red."
    },
    {
      "id": "axi-mobile",
      "name": "Axi Mobile",
      "category": "mobile",
      "status": "p0",
      "surface": "mobile workbench and notification client",
      "glyph": "mobile",
      "accent": {
        "name": "cyan teal",
        "hex": "#14B8A6"
      },
      "prompt": "Central glyph: slim mobile slab intersected by the Axi axial spine, with a small command pulse at the center. Accent color: cyan-teal."
    },
    {
      "id": "axi-verification-inbox",
      "name": "Axi Verification Inbox",
      "category": "security/account",
      "status": "p0",
      "surface": "verification code inbox, OAuth, mailbox tooling",
      "glyph": "inbox",
      "accent": {
        "name": "warm gold",
        "hex": "#FBBF24"
      },
      "prompt": "Central glyph: secure inbox envelope with a small verification keyhole aligned to the Axi trident spine. Accent color: warm gold."
    },
    {
      "id": "axi-docs-search",
      "name": "Axi Docs Search",
      "aliases": [
        "axi-docs"
      ],
      "category": "docs",
      "status": "p0",
      "surface": "documents, SOP search, knowledge index",
      "glyph": "docs",
      "accent": {
        "name": "sky blue",
        "hex": "#38BDF8"
      },
      "prompt": "Central glyph: document stack and search lens merged into a single axial symbol, with the lens forming the center of the Axi spine. Accent color: sky blue."
    },
    {
      "id": "axi-todo",
      "name": "Axi Todo",
      "category": "tooling",
      "status": "p0",
      "surface": "persistent task ledger, todo assistant, daemon",
      "glyph": "todo",
      "accent": {
        "name": "fresh green",
        "hex": "#84CC16"
      },
      "prompt": "Central glyph: checkmark ledger plate crossed by the Axi axial spine, suggesting persistent task state and completion flow. Accent color: fresh green."
    },
    {
      "id": "axi-app-cli",
      "name": "Axi App CLI",
      "category": "tooling",
      "status": "p0",
      "surface": "scaffolder, generated app governance, runtime CLI",
      "glyph": "app-cli",
      "accent": {
        "name": "orange",
        "hex": "#F97316"
      },
      "prompt": "Central glyph: terminal prompt chevron generating a small app tile from the Axi trident spine, precise scaffolding/toolchain feel. Accent color: orange."
    },
    {
      "id": "axi-ollama-menu-assistant",
      "name": "Axi Ollama Menu Assistant",
      "category": "tooling",
      "status": "p0",
      "surface": "local model menu, local voice workflows",
      "glyph": "ollama-menu",
      "accent": {
        "name": "lime cyan",
        "hex": "#A3E635"
      },
      "prompt": "Central glyph: menu bar capsule with local model waveform around the Axi spine, suggesting offline/local assistant control. Accent color: lime-cyan. Avoid animal imagery."
    },
    {
      "id": "axi-model-gateway",
      "name": "Axi Model Gateway",
      "category": "gateway",
      "status": "p0",
      "surface": "model routing, provider profiles, quota references",
      "glyph": "gateway",
      "accent": {
        "name": "blue magenta",
        "hex": "#C084FC"
      },
      "prompt": "Central glyph: routing prism splitting one axial input into three clean output lanes, indicating model gateway and provider routing. Accent color: blue-magenta used sparingly."
    },
    {
      "id": "axi-agent-mcp",
      "name": "Axi Agent MCP",
      "category": "agent",
      "status": "p0",
      "surface": "MCP service, model routing, workflow tools",
      "glyph": "protocol-bridge",
      "accent": {
        "name": "steel cyan",
        "hex": "#67E8F9"
      },
      "prompt": "Central glyph: protocol bridge made of two terminal endpoints connected through the Axi spine, with one small packet pulse. Accent color: steel cyan."
    },
    {
      "id": "axi-agent-transport",
      "name": "Axi Agent Transport",
      "category": "agent",
      "status": "p0",
      "surface": "terminal transport, WebSocket broker, stream runners",
      "glyph": "protocol-bridge",
      "accent": {
        "name": "steel blue",
        "hex": "#60A5FA"
      },
      "prompt": "Central glyph: protocol bridge made of two terminal endpoints connected through the Axi spine, with one small packet pulse. Accent color: steel blue."
    }
  ]
};

export const themePresets = [
  {
    "label": "默认蓝",
    "name": "default",
    "color": "#5D87FF"
  },
  {
    "label": "浅紫",
    "name": "purple",
    "color": "#B48DF3"
  },
  {
    "label": "天空蓝",
    "name": "sky",
    "color": "#1D84FF"
  },
  {
    "label": "绿色",
    "name": "green",
    "color": "#60C041"
  },
  {
    "label": "青色",
    "name": "cyan",
    "color": "#38C0FC"
  },
  {
    "label": "橙色",
    "name": "orange",
    "color": "#F9901F"
  },
  {
    "label": "粉色",
    "name": "pink",
    "color": "#FF80C8"
  }
];

export const primaryShadeMixTarget = "#131313";

export const antdModeTokens = {
  "dark": {
    "colorBgBase": "#121212",
    "colorBgContainer": "#171717",
    "colorBgElevated": "#202020",
    "colorBorder": "#2b2b2b",
    "colorSplit": "#242424",
    "colorText": "#dfe3ee",
    "colorTextSecondary": "#9aa0ad",
    "colorTextTertiary": "#727782"
  },
  "light": {
    "colorBgBase": "#f3f6f8",
    "colorBgContainer": "#ffffff",
    "colorBgElevated": "#ffffff",
    "colorBorder": "#d8e0e8",
    "colorSplit": "#e7edf3",
    "colorText": "#172033",
    "colorTextSecondary": "#667085",
    "colorTextTertiary": "#98a2b3"
  }
};

export const appIconSystem = {
  "name": "Axi Instrument Glass",
  "owner": "@axi/tokens",
  "primaryHex": "#3867E8",
  "backgroundHex": "#101216",
  "masterSize": 1024,
  "exportSizes": [
    512,
    256,
    128,
    64,
    32,
    16
  ],
  "platformMasks": [
    "macos-dock",
    "tauri-window",
    "android-adaptive"
  ],
  "futureProjectCategories": [
    "workbench",
    "agent",
    "ops",
    "docs",
    "notify",
    "mobile",
    "security/account",
    "gateway",
    "tooling"
  ],
  "basePrompt": "Design a premium square app icon for the Axi application suite. Style: mature enterprise developer tool, dark graphite rounded-square base, subtle glass depth, precise beveled edges, crisp central abstract glyph, Axi trident / axial spine motif integrated into the symbol, high legibility at 16px, no text, no letters, no mascot, no busy background, no generic AI purple gradient. Use Axi primary blue #3867E8 plus one restrained accent color. Centered composition, vector-like clean geometry, polished macOS and Android launcher icon quality, 1024x1024.",
  "negativePrompt": "text, letters, wordmark, realistic photo, cute mascot, cartoon, noisy details, excessive glow, purple-blue blob gradient, flat generic SaaS logo, cluttered dashboard screenshot, thin unreadable lines, low contrast, random symbols, app UI mockup inside icon"
};

export const appIconSpecs = [
  {
    "id": "axi-workstation",
    "name": "Axi Workstation",
    "category": "workbench",
    "status": "p0",
    "surface": "control plane, resources, audit, orchestration",
    "glyph": "hub",
    "accent": {
      "name": "electric cyan",
      "hex": "#22D3EE"
    },
    "prompt": "Central glyph: command hub made from three converging axial rails around a small core, suggesting control plane, resources, audit, and orchestration. Accent color: electric cyan. Keep the Axi trident spine visible as the structural center."
  },
  {
    "id": "axi-coder",
    "name": "Axi Coder",
    "category": "workbench",
    "status": "p0",
    "surface": "development workbench, terminal, task execution",
    "glyph": "coder",
    "accent": {
      "name": "emerald green",
      "hex": "#10B981"
    },
    "prompt": "Central glyph: angular code bracket fused with a terminal cursor and axial trident spine, like a precision development cockpit. Accent color: emerald green. Avoid literal code text."
  },
  {
    "id": "axi-agent",
    "name": "Axi Agent",
    "category": "agent",
    "status": "p0",
    "surface": "agent runtime, task orchestration, quality gates",
    "glyph": "agent",
    "accent": {
      "name": "violet blue",
      "hex": "#6366F1"
    },
    "prompt": "Central glyph: autonomous node cluster orbiting a vertical Axi spine, three connected decision points forming a disciplined agent workflow. Accent color: violet-blue, restrained and not gradient-dominant."
  },
  {
    "id": "axi-devsvc-dashboard",
    "name": "Axi DevSvc Dashboard",
    "aliases": [
      "axi-ops-console"
    ],
    "category": "ops",
    "status": "p0",
    "surface": "local services, PM2, workspace status",
    "glyph": "services",
    "accent": {
      "name": "signal green",
      "hex": "#22C55E"
    },
    "prompt": "Central glyph: stacked service layers with a pulse line crossing the Axi trident axis, indicating live local services and health monitoring. Accent color: signal green."
  },
  {
    "id": "axi-fleet-console",
    "name": "Axi Fleet Console",
    "category": "ops",
    "status": "p0",
    "surface": "server fleet registry, inventory, ops executor",
    "glyph": "fleet",
    "accent": {
      "name": "amber",
      "hex": "#F59E0B"
    },
    "prompt": "Central glyph: three server towers connected by an axial command path, compact fleet topology, precise operations console feel. Accent color: amber."
  },
  {
    "id": "axi-notify",
    "name": "Axi Notify",
    "category": "notify",
    "status": "p0",
    "surface": "notification relay, workflow events, inbox",
    "glyph": "notify",
    "accent": {
      "name": "coral red",
      "hex": "#F43F5E"
    },
    "prompt": "Central glyph: notification signal wave contained inside the Axi trident frame, with one clean badge dot, no phone UI screenshot. Accent color: coral red."
  },
  {
    "id": "axi-mobile",
    "name": "Axi Mobile",
    "category": "mobile",
    "status": "p0",
    "surface": "mobile workbench and notification client",
    "glyph": "mobile",
    "accent": {
      "name": "cyan teal",
      "hex": "#14B8A6"
    },
    "prompt": "Central glyph: slim mobile slab intersected by the Axi axial spine, with a small command pulse at the center. Accent color: cyan-teal."
  },
  {
    "id": "axi-verification-inbox",
    "name": "Axi Verification Inbox",
    "category": "security/account",
    "status": "p0",
    "surface": "verification code inbox, OAuth, mailbox tooling",
    "glyph": "inbox",
    "accent": {
      "name": "warm gold",
      "hex": "#FBBF24"
    },
    "prompt": "Central glyph: secure inbox envelope with a small verification keyhole aligned to the Axi trident spine. Accent color: warm gold."
  },
  {
    "id": "axi-docs-search",
    "name": "Axi Docs Search",
    "aliases": [
      "axi-docs"
    ],
    "category": "docs",
    "status": "p0",
    "surface": "documents, SOP search, knowledge index",
    "glyph": "docs",
    "accent": {
      "name": "sky blue",
      "hex": "#38BDF8"
    },
    "prompt": "Central glyph: document stack and search lens merged into a single axial symbol, with the lens forming the center of the Axi spine. Accent color: sky blue."
  },
  {
    "id": "axi-todo",
    "name": "Axi Todo",
    "category": "tooling",
    "status": "p0",
    "surface": "persistent task ledger, todo assistant, daemon",
    "glyph": "todo",
    "accent": {
      "name": "fresh green",
      "hex": "#84CC16"
    },
    "prompt": "Central glyph: checkmark ledger plate crossed by the Axi axial spine, suggesting persistent task state and completion flow. Accent color: fresh green."
  },
  {
    "id": "axi-app-cli",
    "name": "Axi App CLI",
    "category": "tooling",
    "status": "p0",
    "surface": "scaffolder, generated app governance, runtime CLI",
    "glyph": "app-cli",
    "accent": {
      "name": "orange",
      "hex": "#F97316"
    },
    "prompt": "Central glyph: terminal prompt chevron generating a small app tile from the Axi trident spine, precise scaffolding/toolchain feel. Accent color: orange."
  },
  {
    "id": "axi-ollama-menu-assistant",
    "name": "Axi Ollama Menu Assistant",
    "category": "tooling",
    "status": "p0",
    "surface": "local model menu, local voice workflows",
    "glyph": "ollama-menu",
    "accent": {
      "name": "lime cyan",
      "hex": "#A3E635"
    },
    "prompt": "Central glyph: menu bar capsule with local model waveform around the Axi spine, suggesting offline/local assistant control. Accent color: lime-cyan. Avoid animal imagery."
  },
  {
    "id": "axi-model-gateway",
    "name": "Axi Model Gateway",
    "category": "gateway",
    "status": "p0",
    "surface": "model routing, provider profiles, quota references",
    "glyph": "gateway",
    "accent": {
      "name": "blue magenta",
      "hex": "#C084FC"
    },
    "prompt": "Central glyph: routing prism splitting one axial input into three clean output lanes, indicating model gateway and provider routing. Accent color: blue-magenta used sparingly."
  },
  {
    "id": "axi-agent-mcp",
    "name": "Axi Agent MCP",
    "category": "agent",
    "status": "p0",
    "surface": "MCP service, model routing, workflow tools",
    "glyph": "protocol-bridge",
    "accent": {
      "name": "steel cyan",
      "hex": "#67E8F9"
    },
    "prompt": "Central glyph: protocol bridge made of two terminal endpoints connected through the Axi spine, with one small packet pulse. Accent color: steel cyan."
  },
  {
    "id": "axi-agent-transport",
    "name": "Axi Agent Transport",
    "category": "agent",
    "status": "p0",
    "surface": "terminal transport, WebSocket broker, stream runners",
    "glyph": "protocol-bridge",
    "accent": {
      "name": "steel blue",
      "hex": "#60A5FA"
    },
    "prompt": "Central glyph: protocol bridge made of two terminal endpoints connected through the Axi spine, with one small packet pulse. Accent color: steel blue."
  }
];
